const messages = {
    title: "Generer rapport",
    personal_data: {
        title: "Personlige oplysninger",
        email: "E-mail",
        salutation: "Tiltaleform",
        first_name: "Fornavn",
        last_name: "Efternavn",
        job_position: "Stilling i virksomheden"
    },
    shipping_address: {
        title: "Leveringsadresse",
        company: "Firmanavn",
        street: "Gade & husnummer",
        postal_code: "Postnummer",
        mobile_phone: "Mobiltelefon",
        iban_number: "IBAN",
        vat: "CVR-nummer / Momsnummer",
        additional_address: "Supplerende adresse",
        city: "By"
    },
    operating_data: {
        title: "Driftsdata",
        customer_number: "Kundenummer",
        group: "Gruppe",
        customer_group: "Gruppe",
        first_registration: "Første registrering",
        last_login: "Sidste login",
        tires_per_year: "Dæk pr. år",
        over_18_inch: "Over 18 tommer",
        premium: "Premium",
        middle: "Mellem",
        summer: "Sommer",
        winter: "Vinter",
        all_season: "Helårs"
    },
    calculated_data: {
        title: "Beregnet data",
        tireAmount: "Antal dæk",
        points: "Point",
        bonus: "Bonus"
    },
    sales_structure: {
        title: "Salgsstruktur",
        sales_representative: {
            title: "Salgsrepræsentant"
        },
        distributor: {
            title: "Distributør"
        }
    },
    meta: {
        title: "Metadata",
        brand: {
            title: "Mærke",
            none: ""
        },
        tireType: {
            title: "Dæktype",
            none: ""
        },
        year: {
            title: "År",
            "2020": "2020",
            "2021": "2021",
            "2022": "2022",
            "2023": "2023",
            "2024": "2024",
            "2025": "2025"
        },
        calendarMonth: {
            title: "Kalendermåned",
            january: "Januar",
            february: "Februar",
            march: "Marts",
            april: "April",
            may: "Maj",
            june: "Juni",
            july: "Juli",
            august: "August",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "December"
        }
    },
    selectAll: "Vælg alle",
    reset: "Nulstil filtre",
    generate: "Generer rapport",
    loadingInfo: "Rapport genereres, vent venligst..."
};

export default {
    messages,
};
